import { apiRegistro } from '@/plugins/axios'

export default {
  getAllTokens() {
    return apiRegistro().get('/token')
  },
  postNewToken(data) {
    return apiRegistro().post('/token', data)
  },
  deleteToken(idToken) {
    return apiRegistro().delete(`/token/${idToken}`)
  },
}
